// extracted by mini-css-extract-plugin
module.exports = {"container":"yESGO0qw","label":"flHNh7R7","badge":"S80kIp0Y"};